module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "double",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "0em"
    }
  }, [_vm._v("Diversion Books")]), _c('br'), _vm._v("\n\tA Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n\t443 Park Avenue South, Suite 1004"), _c('br'), _vm._v("\n\tNew York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "double",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("Copyright © 1982 by ")]), _c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("Sally Mandel")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")])]), _vm._v(" "), _c('p', {
    staticClass: "double",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tThis is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "double",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("First Diversion Books edition September 2013")]), _c('br'), _vm._v("\n\tISBN: "), _c('span', {
    staticStyle: {
      "font-family": "'Liberation Serif', serif",
      "font-size": "1em",
      "line-height": "1.375",
      "text-align": "justify"
    }
  }, [_vm._v("978-1-62681-125-6")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("\n\tMore by Sally Mandel")]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap161849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Take Me Back"), _c('br'), _vm._v("\n\tChange of Heart"), _c('br'), _vm._v("\n\tHeart and Soul"), _c('br'), _vm._v("\n\tOut of the Blue"), _c('br'), _vm._v("\n\tPortrait of a Married Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap161849",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Time to Sing")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\tFor Barry"), _c('br'), _vm._v("\n\twith my love")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\t￼My gratitude to Peter Lampack for his perspicacity and hard work, to the Writers Room, which is my Shangri-la, and to Maureen Madden Marlowe for herself.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3f41da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Copyright.vue
// module id = 63
// module chunks = 0